<<!--  -->
<template>
  <el-row class="center" style="width:100%;">
    <el-row v-if="status==0" class="mt-100">
      <img src='../../assets/auth/noauth.png' class='auth-tip'/>
      <el-col :span="24" class='fz-14 c-333 line-20 mt-10'>Sorry：您还没有通过审核，请联系QQ:3007128541 提交审核材料</el-col>
    </el-row>

    <el-row v-if="status==1" class="fz-14 mt-100 c-333">
      <img src='../../assets/auth/noauth.png' class='auth-tip'/>
      <el-col :span="24" class="line-20 mt-20">Sorry：您的审核材料没有通过审核</el-col>
      <el-col :span="24" class="line-20 mt-20">原因：{{reason}}</el-col>
      <el-col :span="24" class="line-20 mt-20">请联系QQ:3007128541,重新提交审核材料</el-col>
    </el-row>
  </el-row>
</template>


<script>
export default {
  name: "auth",
  data() {
    return {
      api: {
        getUserInfo: "home/getUserInfo"
      },
      status:'',
      reason:''
    };
  },
  components: {},
  created() {
    this.reason=this.$http.getAuth("user_info").reason;
  },
  mounted() {
    this.getUserinfo();
  },
  methods: {
    getUserinfo() {
      let _this = this;
      this.$http({
        method: "GET",
        url: _this.api.getUserInfo,
        params: {}
      }).then(res => {
        if (res.code == 1) {
          _this.status=res.data.status;
          _this.reason=res.data.reason;
          // this.$http.removeAuth("user_info");
          this.$http.setAuth(res.data.auth_token,res.data);  
          if(res.data.status==2){
            _this.$router.push({
              path:'/mation/overview'
            })
          }else{
            let list=_this.$route.query.list;
            if(list==1){
                _this.$router.psuh({
                  name:'myinfo',
                  query:{}
                })
            }else if(list==2){
               _this.$router.psuh({
                  name:'mypid',
                  query:{}
                })
            }
          }
        }else{
      
        }
      });
    }
  }
};
</script>
<style  scoped>
.center {
  text-align: center;
}
.line-100 {
  line-height: 100px;
}
.line-60{
  line-height:60px;
}
.line-20{
  line-height: 20px;
}
.mt-212{
  margin-top:212px;
}
.mt-100 {
  margin-top: 100px;
}
.mt-20{
  margin-top:20px;
}
.mt-10{
  margin-top:10px;
}
.auth-tip{
  width:216px;
  height:188px;
}
.fz-14{
  font-size:14px;
}
.c-909{
  color:#909399;
}
.c-333{
  color:#333;
}
</style>